import { render } from "./CookiebarActionsArea.ce.vue?vue&type=template&id=e2d5de78"
import script from "./CookiebarActionsArea.ce.vue?vue&type=script&lang=js"
export * from "./CookiebarActionsArea.ce.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__